import { jwtDecode } from 'jwt-decode';
import { isBillingContext, isClientRole } from '../auth/roleUtils';

export function getOfflineOwnerIdentity(token = localStorage.getItem('velaToken')) {
  try {
    if (!token) return null;
    const claims = jwtDecode(token);
    if (!claims.sub || isBillingContext(claims) || isClientRole(claims.role)) return null;
    const contextReferenceId = claims.contextReferenceId || claims.organizationReferenceId || claims.organizationId;
    if (!contextReferenceId) return null;
    const contextType = claims.contextType || 'Organization';
    return {
      ownerKey: `${claims.sub}:${contextType}:${contextReferenceId}`,
      userReferenceId: String(claims.sub),
      contextReferenceId: String(contextReferenceId),
      contextType,
      token,
      expiresAt: Number(claims.exp || 0) * 1000,
    };
  } catch { return null; }
}

export function hasFreshOfflineIdentity() {
  const owner = getOfflineOwnerIdentity();
  return Boolean(owner && owner.expiresAt > Date.now());
}
